import { composeFetch } from '@library/http'
import {
  composeRequest,
  addPath,
  setServiceUrl,
  setMethod,
  setQueryParams,
} from '@library/http/requests'
import { MenuRecipe } from './types'
import { getAuthUserId } from '@library/auth'
import {
  SUPPORTED_OPTION_TYPES_INGREDIENTS,
  SUPPORTED_OPTION_TYPES_RECIPES,
} from '../../internal/types'

export type MenuRecipeParams = {
  menuId: string
  recipeId: string
  numPortions: number
  deliveryDate: string
  collectionId?: string
  ingredientCustomisationsEnabled: boolean
}

const menuApiMenuRecipeParse = async (response: Response): Promise<MenuRecipe> => {
  const body = await response.text()
  const parsedBody = JSON.parse(body)

  if (!response.ok) {
    throw new Error(parsedBody.message)
  }

  return parsedBody as MenuRecipe
}

const menuApiMenuRecipeRequest = composeRequest(
  setServiceUrl('menu', 3),
  addPath(({ menuId, recipeId }: MenuRecipeParams) => `menus/${menuId}/recipes/${recipeId}`),
  setQueryParams(
    ({
      numPortions,
      deliveryDate,
      collectionId,
      ingredientCustomisationsEnabled,
    }: MenuRecipeParams) => {
      const userId = getAuthUserId()
      return {
        num_portions: numPortions.toString(),
        delivery_date: deliveryDate,
        option_types: ingredientCustomisationsEnabled
          ? [...SUPPORTED_OPTION_TYPES_INGREDIENTS]
          : [...SUPPORTED_OPTION_TYPES_RECIPES],
        ...(userId && { user_id: userId }),
        ...(collectionId && { collection_id: collectionId }),
      }
    },
  ),

  setMethod('GET'),
)

export const menuRecipeFetcher = composeFetch(menuApiMenuRecipeRequest, menuApiMenuRecipeParse)
